import React from "react";

export default function renderSponsors(sponsor, sponsors, noTitle) {
  if (sponsors && sponsors.length) {
    return sponsors.map((sponsor) => (
      <div key={`previous_webinars_sponsor_${sponsor.id}`}>
        <p className="webinar_sponsor_logo">
          {sponsor && sponsor.logo_url && (
            <img src={sponsor.logo_url} alt="logo" />
          )}
        </p>
        {sponsor && sponsor.show_sponsor_title && (
          <div className="sponsor_name">
            {sponsor && sponsor.title && <p>{sponsor.title}</p>}
          </div>
        )}
      </div>
    ));
  } else {
    return (
      <div>
        <p className="webinar_sponsor_logo">
          {sponsor && sponsor.logo_url && (
            <img src={sponsor.logo_url} alt="logo" />
          )}
        </p>
        {sponsor && sponsor.show_sponsor_title && (
          <div className="sponsor_name">
            {sponsor && sponsor.title && <p>{sponsor.title}</p>}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/renderSponsors.js